import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import RequestSection from '../../components/RequestSection';
import Footer from '../../components/Footer';




const Home = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [isLandscape, setisLandscape] = useState(false);
    const [fixLandscape, setfixLandscape] = useState(false)
    const [Screen, setScreen] = useState();
    const [scrollNav, setScrollNav] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const changeNav = () => {
        if (window.scrollY > 110) {
            setScrollNav(true);
        } if (window.scrollY < 90) {
            setScrollNav(false);
        }
    }

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            window.addEventListener('scroll', changeNav)
        }
        return () => isSubscribed = false;
    }, [])

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            window.addEventListener("orientationchange", function() {
                // `this` is now pointing to `window`, not the component. So use `self`.
                setScreenOrientation(this.screen.height, this.screen.width);
                
            }, false);
        }
        return () => isSubscribed = false;
    }, [])


    const setScreenOrientation = (height, width) => {
        if(width > height){
            setfixLandscape(true);
            
            if(width > 767){
                setisLandscape(true);
            }else{
                setisLandscape(false);
            }
        }else{
            setisLandscape(false);
            setfixLandscape(false);

        }

        setScreen({height: height, width: width});
      }
    

    return (
        <>
        <div style={styles.cover}>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} isScroll={true} />
            <RequestSection/>
            <Footer/>
            

        </div>
    </>
    )
}



const styles = {
    cover: {
        width: '100%',
        maxWidth: '100vw'
    },
    whatsappWindow:{
       // width: '500px !important'
    }
}
export default Home
